module.exports = __webpack_public_path__ + "static/img/reference pics_suhua tunnel2.beff9cda.jpg";